import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer";
import NewNavbar from "src/components/NewNavbar";
import axios from "axios";
import PageTransition from "src/components/PageTransition";
import { GlobalProvider } from "../../GlobalContext";
// import { useLocation } from "react-router-dom";
import ScrollToTop from "../../components/ScrollOnTop";
export default function Page({ children, variant, routeName }) {
  const [width, setwidth] = useState(window.innerWidth);
  // const { pathname } = useLocation();
  const [navItems, setnavItems] = useState();
  const [innerLogo, setinnerLogo] = useState();
  const [logo, setLogo] = useState();
  const [EventName, setEventName] = useState("");
  useEffect(() => {
    fetchInnerLogo();
    fetchNavigation();
    getEventName();
    function handleResize() {
      setwidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
  }, []);
  async function fetchInnerLogo() {
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_API_SERVER_URL}/logo`)
        .then((response) => {
          setinnerLogo(response.data[0].innerlogo.replace(/\\/g, "/"));
          setLogo(response.data[0].logo.replace(/\\/g, "/"));
        });
    } catch (err) {
      console.log("Inner Logo api error", err);
    }
  }
  async function fetchNavigation() {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_SERVER_URL}/navigation`
      );
  
      if (result.status === 200) {
        const filteredData = result.data.filter((v) => v.value === "1");
        setnavItems(filteredData);
  
        const currentPath = window.location.pathname;
  
        // Check if the current page has value === "0"
        const restrictedItem = result.data.find(
          (item) => item.link === currentPath && item.value === "0"
        );
    
        if (restrictedItem) {
          window.location.href = "/";
        }
      }
    } catch (err) {
      console.error("Navigation error:", err);
    }
  }
  const getEventName = () => {
    axios
      .get(`${process.env.REACT_APP_API_SERVER_URL}/event-details`)
      .then((response) => {
        setEventName(
          response.data[9].value +
            " " +
            response.data[0].value +
            " " +
            response.data[5].value
        );
      });
  };
  useEffect(() => {
    // document.title = routeName ? `${EventName && EventName}` : "Null";
  }, [routeName, EventName]);
  return (
    <>
      <GlobalProvider>
        <ScrollToTop />
        <NewNavbar
          variant={variant}
          navItems={navItems}
          innerLogo={innerLogo}
          logo={logo}
          whiteExpansion={
            routeName === "Contact Us" ||
            routeName === "Pay Online" ||
            routeName === "Slideshare" ||
            routeName === "Booking"
              ? true
              : false
          }
        />
        <PageTransition>
          <div
            style={{
              marginTop: variant === "white" && width > 1024 ? "120px" : null,
            }}
          >
            {children}
          </div>
        </PageTransition>
        <Footer logo={logo} />
      </GlobalProvider>
    </>
  );
}
